exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.control-group[data-v-2b76f2fb] {\n  margin: 20px 0;\n}\n.control[data-v-2b76f2fb] {\n  margin: 10px 0;\n}\nselect[data-v-2b76f2fb] {\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n  height: 35px;\n  width: 300px;\n  background-color: #f2f2f2;\n}\n", ""]);

// exports
